module.exports = __webpack_public_path__ + "img/hall_of_the_eldest_small.10fc0c5c.png";